module.exports = __webpack_public_path__ + "components/flag/static/square/ls-7fe7494a42f6912862d0b0b1f9b125aa.svg";